import { render, staticRenderFns } from "./JobworkReceiptReturnView.vue?vue&type=template&id=4b6e2dba&scoped=true"
import script from "./JobworkReceiptReturnView.vue?vue&type=script&lang=js"
export * from "./JobworkReceiptReturnView.vue?vue&type=script&lang=js"
import style0 from "./JobworkReceiptReturnView.vue?vue&type=style&index=0&id=4b6e2dba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6e2dba",
  null
  
)

export default component.exports